import { render, staticRenderFns } from "./FlatTypeCard.vue?vue&type=template&id=f462d1d2&scoped=true&"
import script from "./FlatTypeCard.vue?vue&type=script&lang=js&"
export * from "./FlatTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./FlatTypeCard.vue?vue&type=style&index=0&id=f462d1d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f462d1d2",
  null
  
)

export default component.exports